import * as ActionType from '../../constants/actionType';

export const setAvailableRoles = (data) => ({type: ActionType.SET_AVAILABLE_ROLES, data});

export const setAvailableRoleRights = (data) => ({type: ActionType.SET_AVAILABLE_ROLE_RIGHTS, data});
